import React from 'react'
import { Checkbox } from '..'

export const RadioButton = props => <Checkbox isRadio {...props} />
